import {breakpoints, gridGutter } from "@olmokit/core/scss";
import { $, $all, on, forEach, addClass } from "@olmokit/dom";
import {
  glide,
  Anchors,
  Autoplay,
  Breakpoints,
  Controls,
  // LazyLoad,
  AutoHeight,
  Swipe,
} from "@olmokit/core/glide";
import "@olmokit/core/glide/bullets";
import "@olmokit/core/glide/arrows";
import "components/NewLook";
import { datalayerProdSlider } from "components/Datalayer";
import "./index.scss";

/**
* Component: VisualSlider
*/

export default function slider(rootSelector) {
  
  datalayerProdSlider(rootSelector, 'gtm-slider', 'true')
  
  let slidelength = $(rootSelector).getAttribute('data-slide');
  
  if (parseInt(slidelength) == 1 ) {
    notSlider(rootSelector);
  } else if (parseInt(slidelength) >= 2 ) {
    startSlider(rootSelector);
  }
  
}

function notSlider(element) {
  // console.log('not slider');
  const root = $(element);
  addClass(root, 'not-slider');
}

function startSlider(element) {
  const $container = `${element ? element + " " : ""}`;
  const slider = glide($container,
    {
      loop: true,
      autoplay: 6000,
      hoverpause: true,
      animationDuration: 900,
      killWhen: { above: 99999 },
      bound: true,
      autoHeight: false, // if true, remove {align-items: center;} from .glide__slides
      breakpoints: {
        [breakpoints.over]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 21, after: gridGutter * 21 },
        },
        [2560]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 16, after: gridGutter * 16 },
        },
        [1920]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 12, after: gridGutter * 12 },
        },
        [1680]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 8, after: gridGutter * 8 },
        },
        [breakpoints.xxl]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 8, after: gridGutter * 8 },
        },
        [breakpoints.xl]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 8, after: gridGutter * 8 },
        },
        [breakpoints.lg]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 6, after: gridGutter * 6 },
        },
        [breakpoints.md]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 4, after: gridGutter * 4 },
        },
        [breakpoints.sm]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 2, after: gridGutter * 2 },
        },
        [480]: {
          perView: 1,
          gap: 0,
          peek: { before: gridGutter * 1.5, after: gridGutter * 1.5 },
        },
      },
    },
    { 
      Anchors, 
      Autoplay, 
      Breakpoints, 
      Controls,
      // LazyLoad, 
      AutoHeight,
      Swipe 
    });
    
    return slider;
  }
